var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('item-element-shops',{attrs:{"shops":_vm._column.shops,"showAdd":_vm.add},on:{"bindshop":_vm.bindshop}})
}
var staticRenderFns = []

export { render, staticRenderFns }